// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loadingEllipsis {
  text-align: center;
  height: 100%;
  width: 100%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  text-align: "center";
}

.lds-ellipsis {
  display: inline-block;
  position: relative;
  width: 64px;
  height: 64px;
  margin: auto;
}

.lds-ellipsis div {
  position: absolute;
  top: 27px;
  width: 11px;
  height: 11px;
  border-radius: 50%;
  background: #697588;
  -webkit-animation-timing-function: cubic-bezier(0, 1, 1, 0);
          animation-timing-function: cubic-bezier(0, 1, 1, 0);
}

.lds-ellipsis div:nth-child(1) {
  left: 6px;
  -webkit-animation: lds-ellipsis1 0.6s infinite;
          animation: lds-ellipsis1 0.6s infinite;
}

.lds-ellipsis div:nth-child(2) {
  left: 6px;
  -webkit-animation: lds-ellipsis2 0.6s infinite;
          animation: lds-ellipsis2 0.6s infinite;
}

.lds-ellipsis div:nth-child(3) {
  left: 26px;
  -webkit-animation: lds-ellipsis2 0.6s infinite;
          animation: lds-ellipsis2 0.6s infinite;
}

.lds-ellipsis div:nth-child(4) {
  left: 45px;
  -webkit-animation: lds-ellipsis3 0.6s infinite;
          animation: lds-ellipsis3 0.6s infinite;
}

@-webkit-keyframes lds-ellipsis1 {
  0% {
    -webkit-transform: scale(0);
            transform: scale(0);
  }
  100% {
    -webkit-transform: scale(1);
            transform: scale(1);
  }
}

@keyframes lds-ellipsis1 {
  0% {
    -webkit-transform: scale(0);
            transform: scale(0);
  }
  100% {
    -webkit-transform: scale(1);
            transform: scale(1);
  }
}
@-webkit-keyframes lds-ellipsis3 {
  0% {
    -webkit-transform: scale(1);
            transform: scale(1);
  }
  100% {
    -webkit-transform: scale(0);
            transform: scale(0);
  }
}
@keyframes lds-ellipsis3 {
  0% {
    -webkit-transform: scale(1);
            transform: scale(1);
  }
  100% {
    -webkit-transform: scale(0);
            transform: scale(0);
  }
}
@-webkit-keyframes lds-ellipsis2 {
  0% {
    -webkit-transform: translate(0, 0);
            transform: translate(0, 0);
  }
  100% {
    -webkit-transform: translate(19px, 0);
            transform: translate(19px, 0);
  }
}
@keyframes lds-ellipsis2 {
  0% {
    -webkit-transform: translate(0, 0);
            transform: translate(0, 0);
  }
  100% {
    -webkit-transform: translate(19px, 0);
            transform: translate(19px, 0);
  }
}`, "",{"version":3,"sources":["webpack://./src/client/components/common/LoadingEllipsis/LoadingEllipsis.scss","webpack://./src/client/Global/Colors.scss"],"names":[],"mappings":"AAEA;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,oBAAA;EAAA,oBAAA;EAAA,aAAA;EACA,oBAAA;AADF;;AAIA;EACE,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;AADF;;AAIA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBC6BO;ED5BP,2DAAA;UAAA,mDAAA;AADF;;AAIA;EACE,SAAA;EACA,8CAAA;UAAA,sCAAA;AADF;;AAIA;EACE,SAAA;EACA,8CAAA;UAAA,sCAAA;AADF;;AAIA;EACE,UAAA;EACA,8CAAA;UAAA,sCAAA;AADF;;AAIA;EACE,UAAA;EACA,8CAAA;UAAA,sCAAA;AADF;;AAIA;EACE;IACE,2BAAA;YAAA,mBAAA;EADF;EAIA;IACE,2BAAA;YAAA,mBAAA;EAFF;AACF;;AALA;EACE;IACE,2BAAA;YAAA,mBAAA;EADF;EAIA;IACE,2BAAA;YAAA,mBAAA;EAFF;AACF;AAKA;EACE;IACE,2BAAA;YAAA,mBAAA;EAHF;EAMA;IACE,2BAAA;YAAA,mBAAA;EAJF;AACF;AAHA;EACE;IACE,2BAAA;YAAA,mBAAA;EAHF;EAMA;IACE,2BAAA;YAAA,mBAAA;EAJF;AACF;AAOA;EACE;IACE,kCAAA;YAAA,0BAAA;EALF;EAQA;IACE,qCAAA;YAAA,6BAAA;EANF;AACF;AADA;EACE;IACE,kCAAA;YAAA,0BAAA;EALF;EAQA;IACE,qCAAA;YAAA,6BAAA;EANF;AACF","sourcesContent":["@import '../../../Global/Colors';\n\n.loadingEllipsis {\n  text-align: center;\n  height: 100%;\n  width: 100%;\n  display: flex;\n  text-align: 'center';\n}\n\n.lds-ellipsis {\n  display: inline-block;\n  position: relative;\n  width: 64px;\n  height: 64px;\n  margin: auto;\n}\n\n.lds-ellipsis div {\n  position: absolute;\n  top: 27px;\n  width: 11px;\n  height: 11px;\n  border-radius: 50%;\n  background: $Gray90;\n  animation-timing-function: cubic-bezier(0, 1, 1, 0);\n}\n\n.lds-ellipsis div:nth-child(1) {\n  left: 6px;\n  animation: lds-ellipsis1 0.6s infinite;\n}\n\n.lds-ellipsis div:nth-child(2) {\n  left: 6px;\n  animation: lds-ellipsis2 0.6s infinite;\n}\n\n.lds-ellipsis div:nth-child(3) {\n  left: 26px;\n  animation: lds-ellipsis2 0.6s infinite;\n}\n\n.lds-ellipsis div:nth-child(4) {\n  left: 45px;\n  animation: lds-ellipsis3 0.6s infinite;\n}\n\n@keyframes lds-ellipsis1 {\n  0% {\n    transform: scale(0);\n  }\n\n  100% {\n    transform: scale(1);\n  }\n}\n\n@keyframes lds-ellipsis3 {\n  0% {\n    transform: scale(1);\n  }\n\n  100% {\n    transform: scale(0);\n  }\n}\n\n@keyframes lds-ellipsis2 {\n  0% {\n    transform: translate(0, 0);\n  }\n\n  100% {\n    transform: translate(19px, 0);\n  }\n}\n","// Brand\n$ElectricGreen: #01FF94;\n$DeepSeaGreen: #002E33;\n$Lavender: #DBD4FF;\n$DayGrey: #EDF1F7;\n\n// Primary\n$Black: #000;\n$White: #FFF;\n$Green: #00E383;\n$Yellow: #FBDB3F;\n$Red: #D92D20;\n$Purple: #5E46D2;\n\n// Blues\n$Blue140: #131C3E;\n$Blue120: #1E267D;\n$Blue110: #2258CE;\n$Blue90: #5E8BEF;\n$Blue60: #7CA2F8;\n$Blue10: #D0E6FE;\n$Blue5: #E4F1FF;\n\n// Purples\n$Purple140: #5D4DAE;\n$Purple20: #F8F6FF;\n\n// Greens\n$Green140: #075E42;\n$Green120: #078E64;\n$Green110: #29B574;\n$Green90: #32D583;\n$Green60: #6CE9A6;\n$Green20: #BAEFCB;\n$Green10: #DDF3E4;\n$Green5: #E8FFF0;\n\n// Yellows\n$Yellow220: #735714;\n$Yellow200: #8F7638;\n$Yellow120: #DCB11A;\n$Yellow30: #FFF8B8;\n$Yellow10: #FFF9CC;\n\n// Reds\n$Red120: #951307;\n$Red110: #C94337;\n$Red90: #F07B70;\n$Red10: #F7DDD9;\n$Red5: #FFF8F6;\n\n// Grays\n$Gray200: #26282F;\n$Gray90: #697588;\n$Gray60: #A7A9B4;\n$Gray50: #D3D6DF;\n$Gray40: #D9DCE5;\n$Gray30: #E8E9F0;\n$Gray20: #F5F6F9;\n$Gray10: #F6F9FF;\n\n// Legacy color variables: Remove these after deprecating @zervant/reactcomponents package\n$shadowColor: #5F6766;\n$normalTextColor: $Gray200;\n$normalBorderColor: $Gray30;\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
